export const RULING_DOCTYPE_NAME = 'Ruling';

export interface IHPCaseSearchRequestBody {
    courtCaseNumber: string;
    docTypename: string;
    docTypeId: string;
}

export interface IHpCaseDocumentType {
    docTypeId: number;
    docTypeName: string;
    ctpShortName: null;
    cptShortName: null;
    cptId: null;
    ctpId: null;
    transType: null;
    parentDocId: null;
    mandatory: null;
    checklistFlag: null;
    auditMessage: string;
}

export interface IHPCaseData {
    courtCaseNumber: string;
    courtUnitId: number;
    courtUnitName: string;
    docId: string;
    docTypeId: number;
    docTypename: string;
    ctpId: number;
    cptId: number;
    receiptTypeId: number;
    receiptTypeName: string;
    restrictionId: number;
    partiesByPrtIdIssuedBy: string;
    partiesByPrtIdReallyIssuedBy: string;
    partyIdCharging: string;
    partiesByPrtIdIssuedByName: string;
    partiesByPrtIdReallyIssuedByName: string;
    partyIdChargingName: string;
    restrictionName: string;
    seqPerCasePh: null;
    dateMailed: null;
    dateReceived: string;
    numberOfCopies: number;
    entryCompleted: null;
    totalCaseValue: null;
    valid: null;
    ccmId: null;
    ccmDesc: null;
    letterNumber: null;
    casePhaseCasId: number;
    casePhaseId: number;
    appealCourtId: null;
    appealCourtName: null;
    ctpShortName: string;
    cptShortName: string;
    validString: null;
    attachmentsData: IHPAttachment[];
    uploadDocTypename: null;
    receivedDate: null;
    uploadDocCasePhTypeId: null;
    transType: null;
    uploadDocTypeId: null;
    uploadDateReceived: null;
    comments: string;
    oldCaseNumber: string;
    suitNumber: string;
    internalDocument: null;
    courtroomId: null;
    feeAssesmentId: null;
    courtType: null;
    isTrackingNumber: null;
    caseCategory: string;
    courtUnitShortName: string;
    hearingProcessDocTypeId: null;
    hearingProcessCasePhTypeId: null;
    hearingCourtUnitId: number;
    hearingCourtUnitName: string;
    docCategory: null;
    resultString: string;
    rulingDocTypeId: number;
    rulingCasePhTypeId: number;
    casePhEvtSequence: null;
    triggeredTaskId: null;
    triggeredTaskDetails: null;
    taskId: null;
    feeAmount: number;
    page: number;
    govtPartyFlag: boolean;
    feeCompTypesId: number;
    feeCompTypesName: null;
    paymentTypes: null;
    pocFeePaymentFlag: boolean;
    feeAssesmentTaskFlag: boolean;
    noBriefsFlag: boolean;
    counselFlag: boolean;
    avoidFeeCheckFlag: boolean;
    filePath: null;
    courtId: number;
    modifiedBy: null;
    courtLevelName: null;
    documentsGridAddMessage: null;
    duplicateDocumentMessage: null;
    feeComponentsData: any[];
    chargeAgainstData: null;
    chargeClaimsData: null;
    docPartiesData: IHPCaseParty[];
    eventsData: any[];
    documentStatus: null;
    judgementDate: string;
    motionDocumentStatus: string;
    auditMessage: string;
}

export interface IHPCaseParty {
    partyId: string;
    partyName: string;
    partyRoleId: number;
    partyRoleName: string;
    timeCreated: string;
    termination: string;
    transType: null;
    representationData: null;
    witnessData: any[];
    auditMessage: string;
}

export interface IHPAttachment {
    docName: string;
    timeCreated: string;
    alfrescoUrl: string;
    docVersion: null;
    alfrescoDocId: null;
    docUploadDateReceived: string;
    docId: null;
    caseId: null;
    casePhaseId: null;
    no: number;
    auditMessage: string;
}